import React from 'react';
import { PropTypes } from 'prop-types';
import SkillBar from '../../ProfileSearch/ProfileDetails/SkillBar/SkillBar';

const DashboardTableExperienceLevel = ({ yearsOfExperience }) => {
  const experienceStrings = splitExperienceString(yearsOfExperience);

  return (
    <div className="my-dashboard__skillbar">
      <SkillBar yearsOfExperience={yearsOfExperience} />
      <div>
        <span style={{ fontWeight: 'bold' }}>{experienceStrings[0]}</span>
        <span>, {experienceStrings[1]}</span>
      </div>
    </div>
  );
};

export function splitExperienceString(str) {
  if (!str) {
    return [];
  }

  const secondPartIdx = str.split('').findIndex((it) => !Number.isNaN(Number(it)) && it !== ' ');

  return [str.substr(0, secondPartIdx - 1), str.substr(secondPartIdx)];
}

DashboardTableExperienceLevel.propTypes = {
  yearsOfExperience: PropTypes.string.isRequired
};

export default DashboardTableExperienceLevel;